import { render } from "./SupplierTransferValues.vue?vue&type=template&id=60fc4e23&scoped=true"
import script from "./SupplierTransferValues.vue?vue&type=script&lang=js"
export * from "./SupplierTransferValues.vue?vue&type=script&lang=js"

import "./SupplierTransferValues.vue?vue&type=style&index=0&id=60fc4e23&scoped=true&lang=css"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60fc4e23"]])

export default __exports__